import { useContext, useEffect, useRef, useState } from 'react'
import { createSearchParams, useParams } from 'react-router-dom'
import {
  ModulesContext,
  SET_MODULES_DATA,
  SET_SELECTED_MODULES_DATA,
  SET_SHOW_HIDE_MODULE_POPUP,
} from './context/context'
import { NavContext } from '../../../context/global_context'
import InputText from '../../common/InputText'
import LinkWithStatus from '../../common/LinkWithStatus'
import Button from '../../common/Button'
import ModulesRow from './ModulesRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import { deleteRequest, getRequest } from '../../../services/base'
import Pagination from '../../common/Pagination'
import ModuleForm from './form'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const Modules = () => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(ModulesContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const currentUrl = useRef(
    `/api/modules/?vehicle=${vehicle}&search=${searchValue}`
  )
  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Modules`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getModulesData()
  }, [])

  const getModulesData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Modules Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(currentUrl.current)
    dispatch({
      type: SET_MODULES_DATA,
      data: { data: res.results, pagination: res.pagination },
    })
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteModule = async (module) => {
    if (
      window.confirm(
        `Are you sure want to delete ${module.acronym}, It will delete all existing mappings`
      ) === true
    ) {
      let res = await deleteRequest(
        `/api/modules/delete/${module?.acronym}/${vehicle}/`
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `${module.acronym} Module Successfully deleted!`,
          },
        })
        setTimeout(() => {
          getModulesData()
        }, 100)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: `Something went wrong!`,
          },
        })
      }
    }
  }

  const onDataSave = (status, msg) => {
    if (status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: msg,
        },
      })

      setTimeout(() => {
        getModulesData()
      }, 100)
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  return (
    <div className="w-full">
      <ModuleForm
        onDataSave={(status, msg) => {
          onDataSave(status, msg)
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Modules`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {
                  currentUrl.current = `/api/modules/?vehicle=${vehicle}&search=${searchValue}`
                  getModulesData()
                }}
              />
            </div>
          </div>
          <div className="w-6/12 flex font-light text-center space-x-5 justify-end content-center items-center">
            <LinkWithStatus
              href={`/administration/module/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Module"
              onClickFunc={() => {
                dispatch({
                  type: SET_SHOW_HIDE_MODULE_POPUP,
                  data: true,
                })
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-3/12 items-center">Acronym</div>
          <div className="flex w-2/12 pl-6 items-center">Module ID</div>
          <div className="flex w-5/12 pl-6 items-center">Connector ID</div>
          <div className="flex w-1/12 pl-6 items-center">Has Dtc</div>
          <div className="flex w-1/12 pl-6 items-center"></div>
        </div>
      </div>
      {state?.data?.data.map((module, index) => {
        return (
          <ModulesRow
            {...module}
            onDelete={() => {
              deleteModule(module)
            }}
            key={`module-${index}`}
            onShowDetails={() => {
              dispatch({
                type: SET_SELECTED_MODULES_DATA,
                data: { ...module, index: index },
              })
            }}
          />
        )
      })}

      {state?.data?.data?.length < 1 && (
        <NoRecordsFound caption={'Modules Data not found'} loading={false} />
      )}

      <div className="py-6">
        <Pagination
          context={state?.data?.pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getModulesData()
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getModulesData()
          }}
        />
      </div>
    </div>
  )
}

export default Modules
